import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "save-template-modal__error"
}

import { ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import { saveSurveyTemplate } from "@/shared/services/surveys.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'SaveSurveyTemplateModal',
  props: {
    surveyId: { default: null },
    onSave: { type: Function, default: undefined }
  },
  setup(__props: any) {

const modal = useModalStore();

const props = __props;

const templateName = ref("");
const isSaving = ref(false);
const errorMessage = ref("");

async function save() {
  if (isSaving.value) return;
  isSaving.value = true;
  errorMessage.value = "";
  try {
    const payload = {
      template_name: templateName.value.trim(),
      survey_id: props.surveyId ?? null,
    };
    await saveSurveyTemplate(payload);
    await props.onSave?.(payload);
    modal.close();
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      (typeof error === "string" ? error : null);
    errorMessage.value = message ? String(message) : "Something went wrong. Please try again.";
  } finally {
    isSaving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "save-template-modal" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "save-template-modal__body" }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "save-template-modal__hint" }, " Give this template a name so you can reuse the same survey structure in the future. ", -1)),
          _createVNode(AppTextField, {
            modelValue: templateName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateName).value = $event)),
            label: "Template name",
            placeholder: "e.g. Standard inspection survey"
          }, null, 8, ["modelValue"]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "save-template-modal__actions" }, {
        default: _withCtx(() => [
          _createVNode(AppButtonFlat, {
            color: "primary",
            block: "",
            "prepend-icon": "mdi-content-save-outline",
            loading: isSaving.value,
            disabled: isSaving.value || !templateName.value.trim(),
            onClick: save
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Save template ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})